import {
    Mutations
} from "vuex-smart-module";

import UtilityCounterState, {
    UtilityCounterStatus
} from "@/store/modules/utility-counter/utility-counter-state";

import {UtilityCounterData} from "@/http/data/utility-counter-data";

import UtilityCounterReadingData from "@/http/data/utility-counter-reading-data";

export default class UtilityCounterMutations
    extends Mutations<UtilityCounterState> {

    setCounters(
        counters: UtilityCounterData[]
    ): void {
        this.state.counters = counters;
    }

    setCountersStatus(
        status: UtilityCounterStatus
    ): void {
        this.state.countersStatus = status;
    }

    setReadings(
        readings: UtilityCounterReadingData[]
    ): void {
        this.state.readings = readings;
    }

    setReadingsStatus(
        status: UtilityCounterStatus
    ): void {
        this.state.readingsStatus = status;
    }

    upsertReading(reading: UtilityCounterReadingData): void {
        this.state.readings = this.state.readings.filter(current => {
            return !(current.counter_id === reading.counter_id && current.date === reading.date);
        });

        this.state.readings.push(reading);
    }

    setSelectedBuildingId(buildingId: null|string): void {
        this.state.selectedBuildingId = buildingId;
    }

    setReadingsPeriod({fromDate, untilDate}: {
        fromDate: string;
        untilDate: string;
    }): void {
        this.state.readingsFromDate = fromDate;
        this.state.readingsUntilDate = untilDate;
    }

    setIsInitialized(value: boolean): void {
        this.state.isInitialized = value;
    }

    clear(): void {
        this.state.counters = [];
        this.state.readings = [];
        this.state.countersStatus = UtilityCounterStatus.Failed;
        this.state.readingsStatus = UtilityCounterStatus.Failed;
        this.state.selectedBuildingId = null;
        this.state.readingsFromDate = null;
        this.state.readingsUntilDate = null;
    }
}